import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09432c6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center items-center" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title leksa_title_50" }, "Восстановление пароля", -1))
const _hoisted_4 = { class: "desc als fz20" }
const _hoisted_5 = { class: "auth common--block" }
const _hoisted_6 = { class: "auth--container" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Вспомнили пароль? Авторизуйтесь", -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_common_inputs = _resolveComponent("common-inputs")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.stage.message), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_common_inputs, {
          inputs: _ctx.auth.inputs,
          data: _ctx.auth.data,
          onInputHandler: _ctx.stage.action
        }, null, 8, ["inputs", "data", "onInputHandler"]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "btn btn--main btn--full",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stage.action && _ctx.stage.action(...args)))
          }, _toDisplayString(_ctx.stage.button), 1)
        ]),
        _createElementVNode("div", {
          class: "flex justify-center als fz16 cursor",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.route('/auth')))
        }, _hoisted_9)
      ])
    ])
  ]))
}